import * as THREE from 'three';
// RGBELoader is deprecated in recent Three.js. Use TextureLoader for standard images, or try using EXRLoader for HDR, or fallback to TextureLoader with warning.
import { TextureLoader } from 'three';
import { EXRLoader } from 'exr-loader';
import { RGBELoader } from 'rgbe-loader';

export class Environment {
    constructor(scene, environmentUrl, threeCanvas, videoInsert, videoCanvas) {
        this.scene = scene;
        this.environmentUrl = environmentUrl;
        this.videoInsert = videoInsert;
        this.realTimeEnvironment = false;
        this.threeCanvas = threeCanvas;
        this.videoCanvas = videoCanvas;
        this.envTexture = null;
        this.customEnvironment(this.scene, this.environmentUrl);
        this.frameCount = 0;
    }

    update() {
        this.frameCount++;

        if (this.frameCount >= 25) {
            if (this.realTimeEnvironment) {
                if (this.envTexture && this.envTexture.isVideoTexture !== false) {
                    this.envTexture.needsUpdate = true;
                } else {
                    this.updateEnvironmentMap();
                }
            }
            this.frameCount = 0;
        }
    } async customEnvironment(scene, environmentUrl) {
        this.realTimeEnvironment = false;

        if (environmentUrl === 'realtime') {
            // Option 2: Environnement en temps réel
            this.realTimeEnvironment = true;
            this.updateEnvironmentMap();
        }
        else if (environmentUrl && environmentUrl !== '') {
            // Option 1: URL vers un fichier HDR/EXR
            if (environmentUrl.endsWith('.hdr')) {
                // Use RGBELoader for .hdr files
                const rgbeLoader = new RGBELoader();
                this.envTexture = await rgbeLoader.loadAsync(environmentUrl);
                this.envTexture.colorSpace = THREE.SRGBColorSpace;
                this.envTexture.mapping = THREE.EquirectangularReflectionMapping;
                this.envTexture.needsUpdate = true;
            } else if (environmentUrl.endsWith('.exr')) {
                // Use EXRLoader for .exr files
                const exrLoader = new EXRLoader();
                this.envTexture = await exrLoader.loadAsync(environmentUrl);
                this.envTexture.colorSpace = THREE.SRGBColorSpace;
                this.envTexture.mapping = THREE.EquirectangularReflectionMapping;
                this.envTexture.needsUpdate = true;
            } else {
                // Use TextureLoader for standard images
                const textureLoader = new TextureLoader();
                this.envTexture = await textureLoader.loadAsync(environmentUrl);
                this.envTexture.colorSpace = THREE.SRGBColorSpace;
                this.envTexture.mapping = THREE.EquirectangularReflectionMapping;
                this.envTexture.needsUpdate = true;
            }
        }
        else {
            // Option 3: Environnement vide (noir)
            this.envTexture = null;
        }

        scene.background = this.envTexture;
        scene.environment = this.envTexture;
    } updateEnvironmentMap() {
        if (this.realTimeEnvironment) {
            // Disposer l'ancienne texture
            if (this.envTexture) {
                this.envTexture.dispose();
            }

            // Créer la nouvelle texture directement
            this.envTexture = new THREE.VideoTexture(this.videoCanvas);
            this.envTexture.isVideoTexture = false;
            // Utiliser SRGBColorSpace pour l'environnement temps réel avec post-processing
            this.envTexture.colorSpace = THREE.SRGBColorSpace;
            this.envTexture.mapping = THREE.EquirectangularReflectionMapping;
            this.envTexture.wrapS = THREE.RepeatWrapping;
            this.envTexture.repeat.x = -1;
            this.envTexture.needsUpdate = true;

            // Mettre à jour la scène et les matériaux directement
            this.scene.background = this.envTexture;
            this.scene.environment = this.envTexture;
            this.updateMaterials();
        }
    }

    updateMaterials() {
        this.scene.traverse((child) => {
            if (child.isMesh && child.material) {
               if(child.material.type === "MeshStandardMaterial"|| child.material.type === "MeshPhysicalMaterial" ){
                child.material.envMap = this.envTexture,
                 child.material.needsUpdate = true;
            }
}
        });

    }

  /**
   * Nettoyage des ressources pour éviter les memory leaks
   */
  dispose() {
    // Disposer de la texture d'environnement
    if (this.envTexture) {
      this.envTexture.dispose();
      this.envTexture = null;
    }

    // Nettoyer les références de la scène
    if (this.scene) {
      this.scene.background = null;
      this.scene.environment = null;
    }

    this.realTimeEnvironment = false;
  }
}
